import { Injectable } from '@angular/core';
import { IndustriesDataService } from '@core/data/api/industry/industries-data.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FetchIndustriesAction, SetIndustriesAction } from './global-actions';
import { INDUSTRIES_FETCH, INDUSTRIES_FETCH_ABORT } from '../action-types';
import { from, map, switchMap, takeUntil } from 'rxjs';
import { ossCatchError } from '@core/operators/catch-error.operator';
import { Industry } from '@core/models/industry/industry';

@Injectable()
export class GlobalEffects {
    constructor(private actions$: Actions,
                private industriesDataService: IndustriesDataService) {
    }

    fetchIndustries$ = createEffect(() => 
        this.actions$
            .pipe(
                ofType<FetchIndustriesAction>(INDUSTRIES_FETCH),
                switchMap(() => {

                    return this.industriesDataService.fetchIndustries()
                        .pipe(
                            takeUntil(this.actions$.pipe(ofType(INDUSTRIES_FETCH_ABORT))),
                            map((response: any) => {

                                return new SetIndustriesAction({
                                    industries: response.industries.map((industry) => Object.assign(new Industry(), industry))
                                });
                            }),
                            ossCatchError(([errorActions, errorResponse]) => from(errorActions))
                        )
                })
            )
    );
}
